<template>
  <v-footer color="#00b1caff" app>
    <span class="white--text">Contact @ https://github.com/hannesortmeier/dicer</span>
  </v-footer>
</template>

<script>
export default {
  name: "Footer"
}
</script>

<style>
</style>
